export default __webpack_public_path__ + "static/391-83913ee85f01dc9830dada745d9876dd.gif";